var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.minimized)?_c('span',[_vm._v(_vm._s(_vm.clients.length ? _vm.handleClientName(_vm.clients[0]) + ' ' : '-'))]):_vm._e(),_c('span',{staticClass:"subtext",class:{ minimized: _vm.minimized },on:{"click":_vm.handleCellClick}},[_vm._v(_vm._s(_vm.handleSubText()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }